// @mui
import { List, Typography } from '@mui/material';
// components
import SkeletonConversationItem from './skeleton/SkeletonConversationItem';
import ChatConversationItem from './ChatConversationItem';
import { useDispatch, useSelector } from 'react-redux';
import { setCurrentConversation } from 'src/redux/slices/chat';
import useResponsive from 'src/hooks/useResponsive';
import { useTranslation } from 'react-i18next';

export default function ChatConversationList({
  conversations,
  isOpenSidebar,
  activeConversationId,
  onSelectConversation,
  sx,
  ...other
}) {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const isDesktop = useResponsive('up', 'md');
  const { isLoading } = useSelector((state) => state.chat);
  const isListEmpty = conversations.length === 0 && !isLoading;

  const handleSelectConversation = (conversation) => {
    let conversationKey = '';
    if (conversation.type === 'GROUP') {
      conversationKey = conversation.id;
    } else {
      const otherParticipant = conversation.participants.find(
        (participant) =>
          participant.id !== '8864c717-587d-472a-929a-8e5f298024da-0'
      );
      if (otherParticipant?.username) {
        conversationKey = otherParticipant?.username;
      }
    }
    dispatch(setCurrentConversation(conversation.id));
    if (!isDesktop) {
      onSelectConversation();
    }
  };

  return (
    <List disablePadding sx={sx} {...other}>
      {(isLoading ? [...Array(12)] : conversations).map(
        (conversation, index) =>
          conversation ? (
            <ChatConversationItem
              key={conversation.id}
              isOpenSidebar={isOpenSidebar}
              conversation={conversation}
              isSelected={activeConversationId === conversation.id}
              onSelectConversation={() =>
                handleSelectConversation(conversation)
              }
            />
          ) : (
            <SkeletonConversationItem key={index} />
          )
      )}
      {isListEmpty && (
        <Typography align="center"> {t('chat.empty_chats_text')}</Typography>
      )}
    </List>
  );
}
